import { NO_SCROLLBARS_CLASS } from "@/src/shared/constants/layout";

export const setLayoutScrollbarsVisibility = (scrollbarsVisible: boolean) => {
  document.body.classList.toggle(NO_SCROLLBARS_CLASS, !scrollbarsVisible);
};
